// Source: app/scripts/controllers/lot.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('LotController', [
  '$scope',
  '$filter',
  '$modal',
  'toaster',
  'Lot',
  function ($scope, $filter, $modal, toaster, Lot) {

    var reloadProducts = function (entity) {
      Lot.getProducts({
        id: entity.id
      }, function (data) {
        if ($scope.lotScope.lot) {
          $scope.lotScope.lot.products = null;
        }
        $scope.lotScope.lotProducts = data;
      });
    };

    var reloadLicenses = function (entity) {
      Lot.getLicenses({
        id: entity.id
      }, function (data) {
        if ($scope.lotScope.lot) {
          $scope.lotScope.lot.licenseTypes = null;
        }
        $scope.lotScope.lotLicenses = data;
      });
    };

    $scope.afterSave = function (lotScope, entity) {
      if (entity.failed) {
        Lot.getCurrent({
          lotCode: entity.code
        }, function (data) {
          lotVersion = data;
          $scope.lotScope.edit(lotVersion.id);
          $scope.lotScope.reload();
        });
      } else {
        lotScope.edit(entity.id);
        lotScope.reload();
      }
    };


    $scope.onNew = function (lotScope, entity) {
      $scope.lotScope.lot = {};
      delete $scope.lotScope.lotProducts;
      delete $scope.lotScope.lotLicenses;
      delete $scope.lotScope.log;
    };

    $scope.onEdit = function (lotScope, entity) {
      $scope.lotScope.lot = {};
      reloadProducts(entity);
      reloadLicenses(entity);
      lotScope.log = Lot.getLog({
        code: entity.code
      });
      lotScope.history = Lot.history({
        code: entity.code
      });
    };

    $scope.afterInit = function (lotScope) {
      lotScope.lot = {};
      // products
      lotScope.afterProductsComboInit = function (comboScope) {
        lotScope.reloadProducts = function () {
          comboScope.reload();
        };
        comboScope.reload();
      };

      lotScope.addProducts = function () {
        var products = lotScope.lot.products;
        Lot.addProducts({
          lotCode: lotScope.entity.code,
          products: products
        }, function () {
          reloadProducts(lotScope.entity);
          lotScope.reloadProducts();
          delete lotScope.lot.products;
          Lot.get({id: lotScope.entity.id}, function (data) {
            lotScope.entity = data;
          });
        });
      };
      lotScope.removeProduct = function (product) {
        Lot.removeProduct({
          lotCode: lotScope.entity.code,
          productCode: product.code
        }, function () {
          reloadProducts(lotScope.entity);
          lotScope.reloadProducts();
//          lotScope.entity = Lot.get({id: lotScope.entity.id});
          Lot.get({id: lotScope.entity.id}, function (data) {
            lotScope.entity = data;
          });
        });
      };

      // licenses
      lotScope.afterLicensesComboInit = function (comboScope) {
        lotScope.reloadLicenses = function () {
          comboScope.reload();
        };
        comboScope.reload();
      };

      lotScope.addLicenses = function () {
        var licenses = lotScope.lot.licenseTypes;
        Lot.addLicenceTypes({
          lotCode: lotScope.entity.code,
          licenseTypes: lotScope.lot.licenseTypes
        }, function () {
          reloadLicenses(lotScope.entity);
          lotScope.reloadLicenses(lotScope.entity);
          delete lotScope.lot.licenseTypes;
          Lot.get({id: lotScope.entity.id}, function (data) {
            lotScope.entity = data;
          });
//          lotScope.entity = Lot.get({id: lotScope.entity.id});
        });
      };

      $scope.lotScope.removeLicense = function (lotLicense) {
        Lot.removeLicenceType({
          id: lotLicense.id
        }, function () {
          reloadLicenses(lotScope.entity);
          lotScope.reloadLicenses(lotScope.entity);
          Lot.get({id: lotScope.entity.id}, function (data) {
            lotScope.entity = data;
          });
        });
      };
    };

    $scope.actions = [{
      text: 'CLOSE',
      name: 'close',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-circle',
      enabled: false,
      onClick: function (entity) {
        $scope.closeEntity.id = entity.id;
        $scope.closeEntity.lotCode = entity.code;
        $scope.modalClose.$promise.then($scope.modalClose.show);
      }
    }, {
      text: 'CANCEL',
      name: 'cancel',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-circle-o',
      enabled: false,
      onClick: function (entity) {
        $scope.cancelEntity.id = entity.id;
        $scope.cancelEntity.lotCode = entity.code;
        $scope.modalCancel.$promise.then($scope.modalCancel.show);
      }
    }, {
      text: 'eauction.markPaid',
      name: 'markPaid',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-money',
      enabled: false,
      onClick: function (entity) {
        $scope.markPaidEntity.id = entity.id;
        $scope.markPaidEntity.lotCode = entity.code;
        $scope.modalMarkPaid.$promise.then($scope.modalMarkPaid.show);
      }
    }, {
      text: 'eauction.enableEdit',
      name: 'enableEdit',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-pencil-square-o',
      enabled: false,
      onClick: function (entity) {
        Lot.enableEdit({
          lotCode: entity.code
        }, function () {
          Lot.getCurrent({
            lotCode: entity.code
          }, function (data) {
            lotVersion = data;
            $scope.lotScope.edit(lotVersion.id);
            $scope.lotScope.reload();
            toaster.pop('success', $filter('translate')('generic.success'),
              $filter('translate')("eauction.enableEditLotMessage"));
          });
        });

//        $scope.lotScope.edit(entity.id);
      }
    }, {
      text: 'SECOND_WINNER',
      name: 'secondWinner',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-ticket',
      enabled: false,
      onClick: function (entity) {
        $scope.secondWinnerEntity.lotId = entity.id;
        $scope.secondWinnerEntity.lotCode = entity.code;
        $scope.secondWinnerEntity.auctionId = entity.auction.id;
//        Lot.findSecondWinners({
//            lotId: entity.id,
//            auctionId: entity.auction.id
//        }, function(data) {
//            $scope.secondWinnerEntity.usersList = data;
//        });
        $scope.modalSecondWinner.$promise.then($scope.modalSecondWinner.show);
      }
    }];

    $scope.closeEntity = {};
    $scope.cancelEntity = {};
    $scope.markPaidEntity = {};
    $scope.secondWinnerEntity = {};
    $scope.modalClose = $modal({
      scope: $scope,
      template: 'forms/modals/lot_close.html',
      show: false
    });
    $scope.modalCancel = $modal({
      scope: $scope,
      template: 'forms/modals/lot_cancel.html',
      show: false
    });
    $scope.modalMarkPaid = $modal({
      scope: $scope,
      template: 'forms/modals/lot_mark_paid.html',
      show: false
    });
    $scope.modalSecondWinner = $modal({
      scope: $scope,
      template: 'forms/modals/lot_second_winner.html',
      show: false
    });

    $scope.close = function () {
      Lot.close({
        lotCode: $scope.closeEntity.lotCode,
        closeReason: $scope.closeEntity.closeReason
      }, function () {
        $scope.modalClose.hide();
        delete $scope.closeEntity.closeReason;
        $scope.lotScope.reload();
        $scope.lotScope.edit($scope.closeEntity.id);
        $scope.closeEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("CLOSED"));
      });
    };
    $scope.cancel = function () {
      Lot.cancel({
        lotCode: $scope.cancelEntity.lotCode,
        cancelReason: $scope.cancelEntity.cancelReason
      }, function () {
        $scope.modalCancel.hide();
        delete $scope.cancelEntity.cancelReason;
        $scope.lotScope.reload();
        $scope.lotScope.edit($scope.cancelEntity.id);
        $scope.cancelEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("CANCELLED"));
      });
    };
    $scope.markPaid = function () {
      Lot.markPaid({
        lotCode: $scope.markPaidEntity.lotCode,
        paymentInformation: $scope.markPaidEntity.paymentInformation,
        contractNumber: $scope.markPaidEntity.contractNumber
      }, function () {
        $scope.modalMarkPaid.hide();
        delete $scope.modalMarkPaid.paymentInformation;
        delete $scope.modalMarkPaid.contractNumber;
        $scope.lotScope.reload();
        $scope.lotScope.edit($scope.markPaidEntity.id);
        $scope.markPaidEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("PAID"));
      });
    };
    $scope.secondWinner = function () {
      Lot.secondWinner({
        lotCode: $scope.secondWinnerEntity.lotCode,
        userId: $scope.secondWinnerEntity.bidder.user.id,
        amount: $scope.secondWinnerEntity.bidder.amount
      }, function () {
        $scope.modalSecondWinner.hide();
        $scope.lotScope.reload();
        $scope.lotScope.edit($scope.secondWinnerEntity.lotId);
        $scope.secondWinnerEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("SECOND_WINNER"));
      });
    };
  }
]);

